export const FETCH_CUSTOMOPTIN_REQUEST = 'FETCH_CUSTOMOPTIN_REQUEST';
export const FETCH_CUSTOMOPTIN_SUCCESS = 'FETCH_CUSTOMOPTIN_SUCCESS';
export const FETCH_CUSTOMOPTIN_FAILURE = 'FETCH_CUSTOMOPTIN_FAILURE';
